import React, {
  ChangeEvent,
} from 'react';
import { FieldProps } from 'formik';
import classnames from 'classnames';

import styles from './CheckboxField.module.scss';

export type CheckboxFieldProps<T> = FieldProps<T> & BasicFieldProps & {
  value: boolean,
};

function FormikCheckboxField<T extends boolean>({
  field: {
    name,
    onChange,
    onBlur,
    value: fieldValue,
  },
  form,
  label,
  value = true,
  disabled = false,
  className,
  helper,
}: CheckboxFieldProps<T>): JSX.Element {
  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    onChange({
      target: {
        name,
        value: e.target.checked ? value : undefined,
      },
    });
  }

  const invalid = (form?.touched?.[name] || false) && (form?.errors?.[name] || false);

  return (
    <div className={classnames(
      styles.checkboxFieldContainer,
      className,
    )}
    >
      <label
        htmlFor={name}
        data-testid={`checkbox-field-${name}`}
        className={classnames(styles.checkboxField, {
          [styles.checkboxFieldDisabled]: disabled,
          [styles.checkboxFieldInvalid]: invalid,
        })}
      >
        <input
          id={name}
          type="checkbox"
          name={name}
          onBlur={onBlur}
          onChange={handleChange}
          checked={value === fieldValue}
          disabled={disabled}
        />
        <div className={styles.fakeCheckbox} />
        {label}
      </label>

      {helper && !invalid && (
        <span
          data-testid={`helper-checkbox-field-${name}`}
          className={styles.helper}
        >
          {helper}
        </span>
      )}
    </div>
  );
}

export default FormikCheckboxField;
